import React from "react";
import styles from "./Loading.module.css";

interface LoadingProps {
	small?: boolean;
}

export function Loading(props: LoadingProps) {
	const { small } = props;
	let classes = styles.loading;
	if (small) {
		classes = `${classes} ${styles.loadingSmall}`;
	}
	return <div className={classes} />;
}

interface CenteredLoadingProps {}

export function CenteredLoading(props: CenteredLoadingProps) {
	return (
		<div className={styles.centeredLoading}>
			<Loading />
			<div className={styles.loadingText}>Loading</div>
		</div>
	);
}

interface OverlayLoadingProps {}

export function OverlayLoading(props: OverlayLoadingProps) {
	return (
		<div className={styles.overlayLoading}>
			<Loading />
			<div className={styles.loadingText}>Loading</div>
		</div>
	);
}
